export { AppointmentTimeSlotsSkeleton } from './AppointmentTimeSlotsSkeleton';
export type { AppointmentTimeSlotsSkeletonProps } from './AppointmentTimeSlotsSkeleton';
export {
  TIME_SLOTS_AREA_MIN_HEIGHT_DESKTOP,
  TIME_SLOTS_AREA_MIN_HEIGHT_MOBILE,
} from './AppointmentTimeSlotsSkeleton';
